/**
 * AuthToken domain model
 * Represents JWT authentication tokens
 */
export interface AuthToken {
  readonly accessToken: string;
  readonly tokenType: string;
  readonly expiresIn: number;
}

/**
 * Factory function to create an AuthToken instance
 */
export const createAuthToken = (data: {
  accessToken: string;
  tokenType: string;
  expiresIn: number;
}): AuthToken => {
  return {
    accessToken: data.accessToken,
    tokenType: data.tokenType,
    expiresIn: data.expiresIn,
  };
};

/**
 * Type guard to check if a token is valid
 */
export const isValidAuthToken = (token: unknown): token is AuthToken => {
  return (
    typeof token === 'object' &&
    token !== null &&
    'accessToken' in token &&
    'tokenType' in token &&
    'expiresIn' in token &&
    typeof (token as AuthToken).accessToken === 'string' &&
    typeof (token as AuthToken).tokenType === 'string' &&
    typeof (token as AuthToken).expiresIn === 'number'
  );
};
